export const IluminacaoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 12.6584H7.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.11745 12.4134C5.63745 11.3675 4.74995 9.5417 5.06245 7.5317C5.40078 5.3592 7.21161 3.62504 9.39578 3.3692C12.4274 3.01337 14.9999 5.37337 14.9999 8.33337C14.9999 10.0209 14.1616 11.51 12.8808 12.415C12.6508 12.5775 12.4999 12.8292 12.4999 13.1109V15.4167C12.4999 16.5675 11.5674 17.5 10.4166 17.5H9.58328C8.43245 17.5 7.49995 16.5675 7.49995 15.4167V13.1142C7.49995 12.83 7.34828 12.5767 7.11745 12.4134Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6665 4.16672L17.6582 3.17505"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33322 12.5L2.34155 13.4917"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16647 3.33334L3.1748 2.34167"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6665 12.5L17.6582 13.4917"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 8.33329H18.9083"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.09155 8.33329H2.49989"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 15H12.3917"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
